import {z as zod} from "zod";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {complexFilterValidator} from "@vesta/vos-types/modules/workspaceLevel/domain/ComplexFilter";

export const adminUserDefinedObjectTemplatesGetValidator = zod.strictObject({
    workspaceId: uuidZodValidator,
    includeArchived: zod.boolean().default(false),
});

/** Distinct text values preserve numeric/JSON precision and are only used by the admin filter picker. */
export const adminUserDefinedObjectColumnValuesValidator = zod.strictObject({
    workspaceId: uuidZodValidator,
    templateId: uuidZodValidator,
    column: zod.string().min(1),
    filters: complexFilterValidator.optional(),
});

const orderByValidator = zod.array(zod.strictObject({
    column: zod.string().min(1),
    direction: zod.enum(["asc", "desc"]),
})).max(20);

export const adminUserDefinedObjectsGetValidator = zod.strictObject({
    workspaceId: uuidZodValidator,
    templateId: uuidZodValidator,
    columns: zod.array(zod.string().min(1)).min(1).max(300).optional(),
    filters: complexFilterValidator.optional(),
    includeDeleted: zod.boolean().default(false),
    limit: zod.number().int().min(1).max(200).default(50),
    offset: zod.number().int().min(0).default(0),
    orderBy: orderByValidator.default([{column: "updatedAt", direction: "desc"}]),
});

export const adminUserDefinedObjectsCountValidator = zod.strictObject({
    workspaceId: uuidZodValidator,
    templateId: uuidZodValidator,
    filters: complexFilterValidator.optional(),
    includeDeleted: zod.boolean().default(false),
});

export const adminUserDefinedObjectQueryValidator = zod.strictObject({
    workspaceId: uuidZodValidator,
    sql: zod.string().trim().min(1).max(50_000),
    limit: zod.number().int().min(1).max(1_000).default(200),
});

export type AdminUserDefinedObjectQuery = zod.output<typeof adminUserDefinedObjectQueryValidator>;

export const adminUserDefinedObjectQueryResultValidator = zod.strictObject({
    columns: zod.array(zod.strictObject({
        name: zod.string(),
        postgresTypeOid: zod.number().int(),
        udoTemplateId: uuidZodValidator.optional(),
        udoAdditionalColumnId: uuidZodValidator.optional(),
    })),
    // Arrays preserve SQL results with duplicate column names.
    rows: zod.array(zod.array(zod.unknown())),
    returnedRowCount: zod.number().int().min(0),
    truncated: zod.boolean(),
    executionTimeMs: zod.number().min(0),
});

export type AdminUserDefinedObjectQueryResult = zod.output<typeof adminUserDefinedObjectQueryResultValidator>;
